var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.pages > 1)?_c('PagePaginateControl',{attrs:{"page":_vm.value,"pages":_vm.pages,"views":_vm.views},on:{"next":_vm.next,"prev":_vm.prev,"set":_vm.set}},[_vm._l((_vm.views),function(name,key){return [_c('button',{key:key,staticClass:"button pagination__item pagination__item_control",class:{
                button_green: _vm.value == name,
                button_orange: _vm.value != name,
            },on:{"click":function($event){return _vm.set(name)}}},[_vm._v(" "+_vm._s(name)+" ")])]})],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }